import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CurrentUser } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {
  private http = inject(HttpClient);

  private url = environment.apiUrl;

  public getAccountData() {
    return this.http.get<CurrentUser>(`${this.url}/User/CurrentUser`);
  }

  public resetPassword(login: string) {
    return this.http.put(`${this.url}/User/ResetPassword`, { login });
  }
}
